import Api from './Api';

const all = (payload) => {
    const path = '/fix-clients';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};
const getOne = (payload) => {
    const path = '/fix-client/get-one';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/fix-client/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/fix-client/update',
        method: 'PUT',
        data: payload
    });
};

const remove = (payload) => {
    return Api.deleteRequest({
        endpoint: `/fix-client/delete/${payload.id}`,
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/fix-client/destroy/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    remove,
    destroy,
    getOne
};
